import { fetcher } from '../utils'

export default async (connectionKey: string, phoneNumber: string): Promise<void> =>
  fetcher(`/api/contact/unblock/${connectionKey}/${phoneNumber}`, 'PUT', undefined)
